import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface LandscapingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Landscaping: React.FC<LandscapingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [landscaping, set_landscaping] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Final Steps']?.['Landscaping'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Steps': { ...b.values?.['Final Steps'], 'Landscaping': v } } })
    );
    const label = 'Landscaping';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(landscaping)}
                />
            ) : (
                <MoneyBox
                    id={'landscaping'}
                    allowNegative={false}
                    value={landscaping}
                    onChange={(value) => set_landscaping(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
